import { displayErrorFeedbackMessage } from './utilities';

(function($)
{
// METHODS POOL

    var placeholder = '<span class="csv-placeholder">24702411020&#09;1<br>24702411020;1<br>24702411020,1</span>';

    // Set initial csv-placeholder into edit-area
    $('#edit-input').html(placeholder);

    // Remove csv-placeholder when input-area is selected
    $('#edit-input').on('click', function()
    {
        $('.csv-placeholder').remove();
    });

    // Set csv-placeholder when input-area is NOT selected
    $(document).mouseup(function(e)
    {
        if (!$('#edit-input').is(e.target))
        {
            setPlaceholderIfEmpty();
        }
    });

    // Checks if input-area is empty and sets placeholder
    function setPlaceholderIfEmpty()
    {
        if ($('#edit-input').text().length == 0)
        {
            $('#edit-input').html(placeholder);
        }
    }

    // Remove placeholder from input-area
    function removePlaceholder()
    {
        $('.csv-placeholder').remove();
    }

    var csvOrder = (function($)
    {
        console.log('init csvOrder');

        var
            $body = $('body'),
            fn  = {},
            /*
			 *	json    = undefined,
			 *	csv =undefined,
			 */
            $checkButtonSelector = $('#csv-order-check'),
            $submitButtonSelector = $('#csv-order-submit'),
            /*
			 *	$resetButtonSelector = $('#csv-order-reset'),
			 *	feedbackUnknownHeading = $('meta[itemprop="feedback-unknown-heading"]').attr('content'),
			 */
            feedbackUnknownInline = $('meta[itemprop="feedback-unknown-inline"]').attr('content'),
            feedbackUnknownText = $('meta[itemprop="feedback-unknown-text"]').attr('content'),
            /*
			 *	feedbackSyntaxErrorHeading = $('meta[itemprop="feedback-syntax-error-heading"]').attr('content'),
			 *	feedbackSyntaxErrorText = $('meta[itemprop="feedback-syntax-error-text"]').attr('content'),
			 */
            feedbackSyntaxErrorInline = $('meta[itemprop="feedback-syntax-error-inline"]').attr('content'),
            feedbackQuantityErrorInline = $('meta[itemprop="feedback-quantity-error-inline"]').attr('content'),
            feedbackSuccessHeading = $('meta[itemprop="feedback-success-heading"]').attr('content'),
            feedbackFormatValidationText = $('meta[itemprop="feedback-format-validation-text"]').attr('content'),
            feedbackInvalidFileText = $('meta[itemprop="feedback-invalid-file-text"]').attr('content'),
            //	handleFileSelect    = function(){},
            getResultSetForTextArea = function()
            {},
            //	csvLineValidationMissingLeadingZero = function(){},
            csvLineValidation   = function()
            {},
            /*
			 *	csvLineSoftValidation    = function (){},
			 *	removeInvalidCsvLines = function() {},
			 *	parseCsvLineArrayToJsonArray = function() {},
			 *	splitJsonArrayIntoChunksArray   = function(){},
			 */
            updateProgressBar    = function()
            {},
            //	cartItemApiCall = function (){},
            showInvalidItemList = function()
            {},
            unlockFurtherProcessing = function()
            {},
            lockFurtherProcessing = function()
            {},
            getCsvLineArrayFromEditInput = function()
            {},
            showUpdatedItemcount    = function()
            {};

        // 2 METHODS
        var handleFileSelect = function(evt)
        {
            removePlaceholder();
            evt.stopPropagation();
            evt.preventDefault();

            var file = '';

            if (evt.target.files !== undefined)
            {
                [file] = evt.target.files;
                $('#upload-file').val('');
            }
            else
            {
                [file] = evt.dataTransfer.files;
            }
            if (
                file !== undefined
                && (file.name.endsWith('.csv')
                || file.name.endsWith('.txt'))
            )
            {
                var $window = $(window);
                var reader = new FileReader();

                reader.readAsText(file);
                reader.onprogress = function()
                {
                    $window.on('beforeunload', function()
                    {
                        return false;
                    });
                };
                reader.onload = function(event)
                {
                    var csv = event.target.result;

                    $('#edit-input').html(csv);
                    checkInput();
                    $window.off('beforeunload');
                };
            }
            else
            {
                $body.append('<div class="feedback error js-feedback">'
                    + '<i class="fa-regular fa-exclamation-circle"></i><p>'
                    + feedbackInvalidFileText
                    + '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');
                $body.trigger('feedback-added');
            }
            setPlaceholderIfEmpty();
        };

        function checkInput()
        {
            removePlaceholder();
            var csvLineArray = getCsvLineArrayFromEditInput();

            $('#edit-input').html(getResultSetForTextArea(csvLineArray));

            var $inputElements = $('p', '#edit-input');
            var $errorElements = $('p.error', '#edit-input');

            if (!$inputElements.length || ($inputElements.length === $errorElements.length))
            {
                lockFurtherProcessing();
            }
            else
            {
                unlockFurtherProcessing();
            }
            if ($errorElements.length > 0)
            {
                showValidationFeedback($errorElements.length, $inputElements.length);
            }
            setPlaceholderIfEmpty();
        }

        function handleDragOver(evt)
        {
            removePlaceholder();
            evt.stopPropagation();
            evt.preventDefault();
            evt.dataTransfer.dropEffect = 'copy';
            setPlaceholderIfEmpty();
        }

        function showValidationFeedback(errorCount, inputCount)
        {
            var $message
			= $('<div class="feedback error js-feedback js-feedback-autohide">'
                + '<i class="fa-regular fa-exclamation-circle"></i><p>'
			+ feedbackFormatValidationText
			+ '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');

            $('body').append($message);
            $('body').trigger('feedback-added');
            $('.lines-with-error-count').text(errorCount);
            $('.total-lines-count').text(inputCount);
        }

        getResultSetForTextArea = function(csvLineArray)
        {
            var textAreaResultSet = '';

            for (var i = 0; i < csvLineArray.length; i++)
            {
                var rawCsvLine = csvLineArray[i];

                if ($.trim(rawCsvLine) !== '')
                {
                    var csvLine = editRawCsvLine(rawCsvLine);

                    if (csvLineValidation(csvLine))
                    {
                        // everything is fine concerning syntax
                        textAreaResultSet += '<p>' + csvLine + '</p>';
                    }
                    else if (csvLineCheckIfProductNumberInvalid(csvLine))
                    {
                        // error most likely in product number
                        textAreaResultSet += '<p class="feedback inline error" title="'
                            + feedbackSyntaxErrorInline + '">' + rawCsvLine + '</p>';
                    }
                    else if (csvLineCheckIfProductQuantityInvalid(csvLine))
                    {
                        // error most likely in quantity
                        textAreaResultSet += '<p class="feedback inline error" title="'
                            + feedbackQuantityErrorInline + '">' + rawCsvLine + '</p>';
                    }
                    else
                    {
                        // could not pinpoint the input error -> show original input with highlight
                        textAreaResultSet += '<p class="feedback inline error">' + rawCsvLine + '</p>';
                    }
                }
            }

            return textAreaResultSet;
        };

        // tries to edit a raw csv line to a valid input line by treating common mistakes
        var editRawCsvLine = function(rawCsvLine)
        {
            var processedCsvLine = rawCsvLine;
            // delete unnecessary signs

            processedCsvLine = processedCsvLine.replace(/ /g, '');
            processedCsvLine = processedCsvLine.replace(/-/g, '');
            processedCsvLine = processedCsvLine.replace(/\./g, '');
            // cut off everything at the end thats not a digit (needed for file upload)
            processedCsvLine = processedCsvLine.replace(/[^\d]*$/g, '');

            if (csvLineCheckIfLeadingZeroMissing(processedCsvLine))
            {
                processedCsvLine = '0' + processedCsvLine;
            }
            else if (csvLineCheckIfSixDigitProductNumberWasUsed(processedCsvLine))
            {
                processedCsvLine = handleSixDigitProductNumber(processedCsvLine);
            }

            return processedCsvLine;
        };

        // checks if the product number has 10 digits with the first not being a 0
        var csvLineCheckIfLeadingZeroMissing = function(csvLine)
        {
            var pattern = /(^[1-9])(\d{9})([,;\t]{1})(\d{1,6})$/;

            return pattern.test(csvLine);
        };

        // checks if the product number has 6 digits
        var csvLineCheckIfSixDigitProductNumberWasUsed = function(csvLine)
        {
            var pattern = /^(\d{6})([,;\t]{1})([0-9]?[1-9][0-9]{0,5})$/;

            return pattern.test(csvLine);
        };

        csvLineValidation = function(csvLine)
        {
            var pattern = /(^\d{8}|^\d{11,13})([,;\t]{1})([0-9]?[1-9][0-9]{0,5})$/;

            return pattern.test(csvLine);
        };

        var csvLineCheckIfProductNumberInvalid = function(csvLine)
        {
            var patternProductNumberValid = /(^\d{11}|^\d{13})([,;\t]{1})(.+)$/;

            if (patternProductNumberValid.test(csvLine))
            {
                return false;
            }
            var pattern = /(^\w{1,15})([,;\t]{1})(.+)/;

            return pattern.test(csvLine);
        };

        var csvLineCheckIfProductQuantityInvalid = function(csvLine)
        {
            var pattern = /(^\d{11}|^\d{13})([,;\t]{1})(\w{1,10})$/;

            return pattern.test(csvLine);
        };

        // turns six digit product number into eleven digit product number
        var handleSixDigitProductNumber = function(csvLine)
        {
            var productNumber = csvLine.substr(0, 6);
            var csvLineWithElevenDigitProductNumber = csvLine.replace(productNumber, '0' + productNumber + '0000');

            return csvLineWithElevenDigitProductNumber;
        };

        var removeInvalidCsvLines = function(csvLineArray)
        {
            var tempCsvLineArray = [];

            for (var i = 0; i < csvLineArray.length; i++)
            {
                var trimmedCsvLine = csvLineArray[i].trim();

                if (csvLineValidation(trimmedCsvLine))
                {
                    tempCsvLineArray.push(trimmedCsvLine);
                }
            }
            return tempCsvLineArray;
        };

        var parseCsvLineArrayToJsonArray = function(csvLineArray, overwriteDuplicateKeys, skipDuplicateKeys)
        {
            console.log('parseCsvLineArrayToJsonArray');
            var hash = {};

            overwriteDuplicateKeys = (typeof overwriteDuplicateKeys === 'undefined') ? true : overwriteDuplicateKeys;
            skipDuplicateKeys = (typeof skipDuplicateKeys === 'undefined') ? false : skipDuplicateKeys;

            var csvValuePair,
                key, value;

            for (var i = 0; i < csvLineArray.length; i++)
            {
                csvValuePair = csvLineArray[i].split(/\D/);
                [key] = csvValuePair;
                value = parseInt(csvValuePair[1], 10);
                var product;

                if (key.length === 11)
                {
                    product = {
                        productNumber: key,
                        quantity: value
                    };
                }
                else if (key.length === 8 || key.length > 11 && key.length < 14)
                {
                    product = {
                        barcode: key,
                        quantity: value
                    };
                }
                else
                {
                    console.log('some unresolved error');
                    continue;
                }

                if (Object.prototype.hasOwnProperty.call(hash, key))
                {
                    if (skipDuplicateKeys)
                    {
                        // ignore duplicates
                        continue;
                    }
                    else if (!overwriteDuplicateKeys)
                    {
                        // add quantities if overwrite is disabled
                        product.quantity += hash[key].quantity;
                    }
                }

                hash[key] = product;
            }

            var array = [];

            for (var k in hash)
            {
                if (Object.prototype.hasOwnProperty.call(hash, k))
                {
                    array.push(hash[k]);
                }
            }

            return array;
        };

        var splitJsonArrayIntoChunksArray = function(jsonArray)
        {
            var JSON_LENGTH = 100;
            var chunks = [];
            var array = [];

            for (var i = 0; i < jsonArray.length; i++)
            {
                array.push(jsonArray[i]);

                if (array.length >= JSON_LENGTH)
                {
                    chunks.push(array);
                    array = [];
                }
            }
            if (array.length)
            {
                chunks.push(array);
            }
            return chunks;
        };

        updateProgressBar = function(value)
        {
            var progressValueRounded = Math.ceil(value);
            var progressValuePercentage = progressValueRounded + '%';

            console.log('updateProgressBar(): called');
            console.log(progressValuePercentage);

            $('#directorder-csv-progress').removeClass('hidden');
            $('.overlay.focus').css({
                'opacity' : '1',
                'visibility' : 'visible'
            });
            $('div.progress-meter').css('width', progressValuePercentage);
            $('p.progress-meter-text').text(progressValuePercentage);

            if (progressValueRounded == 100)
            {
                setTimeout(function()
                {
                    $('#directorder-csv-progress').addClass('hidden');
                    $('.overlay.focus').css({
                        'opacity': '0',
                        'visibility': 'hidden'
                    });
                }, 1000);
            }
        };

        var cartItemApiCall = function(chunks, overwriteBasket)
        {
            var url = overwriteBasket ? '/v1-api-cart-list-de/replace' : '/v1-api-cart-list-de/add';

            var i = 0;
            var successfullChunks = 0;
            var apiCallResult = [];
            var updatedItemcount = 0;

            function chunkAjax()
            {
                if (successfullChunks >= 1)
                {
                    url = '/v1-api-cart-list-de/add';
                }

                var progress = (i / chunks.length) * 100;

                updateProgressBar(progress);

                if (i < chunks.length)
                {
                    $.ajax({
                        type: 'POST',
                        url: url,
                        data: JSON.stringify(chunks[i]),
                        contentType: 'application/json; charset=utf-8',
                        timeout: 20000,
                        success: function(serverResponse)
                        {
                            var serverResponseJson = JSON.parse(serverResponse);

                            updatedItemcount += serverResponseJson.updatedItemCount;
                            if (serverResponseJson.invalidItemList.length)
                            {
                                $.each(serverResponseJson.invalidItemList, function(key, value)
                                {
                                    apiCallResult.push(value);
                                });
                            }

                            i++;
                            successfullChunks++;
                            chunkAjax();
                        },
                        error: function(XHR, status, errorThrown)
                        {
                            if (errorThrown === 'Forbidden')
                            {
                                $('#directorder-csv-progress').addClass('hidden');
                                $('#overlay-login').removeClass('hidden');
                            }
                            else
                            {
                                i++;
                                chunkAjax();
                            }

                            // skipped will be processed in later release
                        },
                    });
                }
                else
                {
                    showUpdatedItemcount(updatedItemcount);
                    showInvalidItemList(apiCallResult);
                    $body.trigger(orion.constants.EventCartProductCreated, chunks[0][0]);
                }
            }

            chunkAjax();
            // $('#directorder-csv-progress').addClass('hidden');
        };

        unlockFurtherProcessing = function()
        {
            $checkButtonSelector.addClass('hidden');
            $submitButtonSelector.removeClass('hidden');
        };

        lockFurtherProcessing = function()
        {
            $checkButtonSelector.removeClass('hidden');
            $submitButtonSelector.addClass('hidden');
        };

        showUpdatedItemcount = function(updatedItemcount)
        {
            var $successMessageElement = $(
                '<div id="success-message" class="js-feedback js-feedback-autohide feedback success">'
                + '<i class="fa-regular fa-check ok"></i>'
                + '<p>' + feedbackSuccessHeading + '</p></div>'
            );

            $('body').append($successMessageElement);
            $('body').trigger('feedback-added');
            $('.updatedItemCount').text(updatedItemcount);
        };

        showInvalidItemList = function(invalidItemList)
        {
            var $editInput = $('#edit-input');

            $editInput.html('');
            var result = '';

            $.each(invalidItemList, function(key, value)
            {
                var productId = value.productNumber;

                if (productId === undefined)
                {
                    productId = value.barcode;
                }
                result += '<p class="feedback inline unknown" title="' + feedbackUnknownInline + '">'
                + productId + ';' + value.quantity + '</p>';
            });

            if (invalidItemList.length)
            {
                let errorFeedbackMessage = displayErrorFeedbackMessage(feedbackUnknownText);

                if (errorFeedbackMessage)
                {
                    errorFeedbackMessage.querySelector('.js-unknown-number').innerText = invalidItemList.length;
                }
            }

            $editInput.html(result);
        };

        getCsvLineArrayFromEditInput = function()
        {
            var text = document.getElementById('edit-input').innerText;

            return text.trim().split('\n');
        };

        // PUBLIKATION

        fn = {
            handleFileSelect    :handleFileSelect,
            checkInput : checkInput,
            handleDragOver : handleDragOver,
            removeInvalidCsvLines : removeInvalidCsvLines,
            parseCsvLineArrayToJsonArray : parseCsvLineArrayToJsonArray,
            splitJsonArrayIntoChunksArray   :splitJsonArrayIntoChunksArray,
            cartItemApiCall :cartItemApiCall,
            csvLineValidation : csvLineValidation,
            getResultSetForTextArea : getResultSetForTextArea,
            lockFurtherProcessing : lockFurtherProcessing,
            unlockFurtherProcessing : unlockFurtherProcessing,
            getCsvLineArrayFromEditInput : getCsvLineArrayFromEditInput
        };
        return fn;
    })(jQuery);

    // EVENT STACK
    $(document).ready(function()
    {
        var $container = $('#csv-input', $container);
        removePlaceholder();
        if (0 === $container.length)
        {
            return;
        }
        setPlaceholderIfEmpty();

        /**
		 * Upload File
		 */
        document.getElementById('upload-file').addEventListener('change', csvOrder.handleFileSelect, false);
        var dragAndDropField = document.getElementById('csv-drag-and-drop-field');

        dragAndDropField.addEventListener('dragover', csvOrder.handleDragOver);
        dragAndDropField.addEventListener('drop', csvOrder.handleFileSelect);

        var editArea = document.getElementById('csv-edit-area');

        editArea.addEventListener('dragover', csvOrder.handleDragOver);
        editArea.addEventListener('drop', csvOrder.handleFileSelect);

        /**
		 * Handle ChangeEvents in EditDiv
		 */
        $('#edit-input').on('keydown', function(event)
        {
            switch (event.which)
            {
            case 9:
                event.preventDefault();
                var range = window.getSelection().getRangeAt(0);

                var tabNode = document.createTextNode('\u0009');

                range.insertNode(tabNode);

                range.setStartAfter(tabNode);
                range.setEndAfter(tabNode);
                break;
            }
        });
        /**
		 * Handle ChangeEvents in EditDiv
		 */
        $('#edit-input').on('keyup', function(event)
        {
            switch (event.which)
            {
            case 9: // Tab
            case 27: // ESC
            case 16: // ctrl
            case 17: // ctrl
            case 18: // alt
            case 33: // pgup
            case 34: // pgdown
            case 35: // ende
            case 36: // pos1
            case 37: // left
            case 38: // up
            case 39: // right
            case 40: // down
                break;
            default:
                csvOrder.lockFurtherProcessing();
            }
            $(this).find('p, span')
                .each(function(idx, span)
                {
                    if ($.trim(span.innerText) == '')
                    {
                        $(span).attr('class', '')
                            .attr('title', '');
                        $(span).html('<br/>');
                    }
                });
        });

        /**
		 * Handle Click on CheckButton
		 */
        $('#csv-order-check').on('click', function(event)
        {
            removePlaceholder();
            event.preventDefault();
            csvOrder.checkInput();
            setPlaceholderIfEmpty();
        });

        $('#csv-order-submit').on('click', function(event)
        {
            removePlaceholder();
            event.preventDefault();

            var csvLineArray = csvOrder.getCsvLineArrayFromEditInput();

            csvLineArray = csvOrder.removeInvalidCsvLines(csvLineArray);
            var jsonArray = csvOrder.parseCsvLineArrayToJsonArray(csvLineArray, false, false);

            $('span#itemCountDialog').text(csvLineArray.length);

            if ($('.js-basket-onsite-not-empty', '#basket-onsite').hasClass('hidden'))
            {
                csvOrder.lockFurtherProcessing();
                // Add-to Cart
                csvOrder.cartItemApiCall(
                    csvOrder.splitJsonArrayIntoChunksArray(jsonArray),
                    false
                );
            }
            else
            {
                $('body').addClass('focus-active');
                $('#overlay-directorder-csv').removeClass('hidden');
                $('.overlay.focus').css({
                    'opacity' : '1',
                    'visibility' : 'visible'
                });

                $('#overlay-directorder-csv a.close-overlay, #overlay-directorder-csv a.close, .overlay.focus')
                    .click(function(event)
                    {
                        event.preventDefault();
                        $('body').removeClass('focus-active');
                        $('#overlay-directorder-csv').addClass('hidden');
                        // Close Overlay
                        $('.overlay.focus').css({
                            'opacity' : '0',
                            'visibility' : 'hidden'
                        });
                    });

                $('#overlay-directorder-csv a.add-to-cart').off('click')
                    .on('click', function(event)
                    {
                        event.preventDefault();
                        $('body').removeClass('focus-active');
                        $('#overlay-directorder-csv').addClass('hidden');
                        csvOrder.lockFurtherProcessing();
                        // Add-to Cart
                        csvOrder.cartItemApiCall(
                            csvOrder.splitJsonArrayIntoChunksArray(jsonArray),
                            false
                        );
                    });

                $('#overlay-directorder-csv a.replace-cart').off('click')
                    .on('click', function(event)
                    {
                        event.preventDefault();
                        $('body').removeClass('focus-active');
                        $('#overlay-directorder-csv').addClass('hidden');
                        csvOrder.lockFurtherProcessing();
                        // replace cart
                        csvOrder.cartItemApiCall(
                            csvOrder.splitJsonArrayIntoChunksArray(jsonArray),
                            true
                        );
                    });
            }
            setPlaceholderIfEmpty();
        });

        $('#csv-order-reset').click(function(event)
        {
            event.preventDefault();
            $('#edit-input').html(placeholder);
            csvOrder.lockFurtherProcessing();
        });

        // @see https://stackoverflow.com/questions/12027137/javascript-trick-for-paste-as-plain-text-in-execcommand
        $('[contenteditable]').on('paste', function(e)
        {
            removePlaceholder();
            e.preventDefault();
            var text = '';

            if (e.clipboardData || e.originalEvent.clipboardData)
            {
                text = (e.originalEvent || e).clipboardData.getData('text/plain');
            }
            else if (window.clipboardData)
            {
                text = window.clipboardData.getData('Text');
            }
            if (document.queryCommandSupported('insertText'))
            {
                document.execCommand('insertText', false, text);
            }
            else
            {
                document.execCommand('paste', false, text);
            }
            setPlaceholderIfEmpty();
        });
    });
})(jQuery);
